import type { XMediaPartialType, XTagType } from '@/components/pages/content/types';

import Icon from '@/components/base/Icon';
import { InitialTweetAuthor } from '@/components/composite/MediaViewer/PostPreview/PreviewTwitter/InitialTweetAuthor';
import { Status } from '@/components/composite/MediaViewer/PostPreview/PreviewTwitter/Status';

type QuotedTweetContentProps = {
    post?: XMediaPartialType;
    getFormattedCaption: (caption?: string, tags?: XTagType[]) => React.ReactNode;
};

export const QuotedTweetContent = ({ post, getFormattedCaption }: QuotedTweetContentProps) => {
    const hasRelatedTweet = Boolean(post?.data?.related_tweet);

    if (hasRelatedTweet) {
        return (
            <div className="mb-8 space-y-2 rounded-md bg-icoGray-300 p-m dark:bg-icoDarkMode-anthracite">
                <InitialTweetAuthor post={post} />
                <Status
                    caption={getFormattedCaption(
                        post?.data?.related_tweet?.caption,
                        post?.data?.related_tweet?.tags
                    )}
                    tags={post?.data?.related_tweet?.tags}
                    className={'font-GMedium text-xs'}
                />
            </div>
        );
    }

    const isLinkMedia = post?.medias?.[0]?.type === 'link';

    if (isLinkMedia) {
        return (
            <a
                href={post?.medias?.[0]?.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mb-8 flex items-center space-x-2 rounded-md bg-icoGray-300 p-m text-xs text-icoBlue dark:bg-icoDarkMode-anthracite">
                <Icon icon="link" className="text-xxs" />
                <span className="truncate">
                    {(post?.medias?.[0] as { text?: string })?.text || post?.medias?.[0]?.link}
                </span>
            </a>
        );
    }

    return null;
};
